import useCustomBottomSheet from 'hooks/useCustomBottomSheet';
import { useAnimatedStyle } from 'react-native-reanimated';
import { useParkingStore } from 'stores/parkingStore';
import { isWeb } from 'utils/deviceUtils';

const useOngoingSessionsSheet = () => {
  const { animatedIndex } = useCustomBottomSheet();
  const isExpanded = !!useParkingStore((state) => state.selectedOngoingSession);

  const expandedContainerAnimatedStyle = useAnimatedStyle(() => {
    return {
      display:
        animatedIndex.value >= 0.5 || (isWeb && isExpanded) ? 'flex' : 'none',
      flexDirection: 'row',
    };
  });

  const collapsedManualContainerAnimatedStyle = useAnimatedStyle(() => {
    return {
      display:
        animatedIndex.value >= 0.5 || (isWeb && isExpanded) ? 'none' : 'flex',
      flexDirection: 'row',
    };
  });

  return {
    collapsedSheetContainerStyle: collapsedManualContainerAnimatedStyle,
    expandedSheetContainerStyle: expandedContainerAnimatedStyle,
  };
};

export default useOngoingSessionsSheet;
